<template>
  <AlertDialogTitle
    :as-child="props.asChild"
    :class="cn('text-lg font-semibold', props.class)"
  >
    <slot />
  </AlertDialogTitle>
</template>

<script setup>
import { AlertDialogTitle } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps();
</script>
